export const usuarioFilterFields = [
  {
    name: "nome",
    label: "Nome",
    placeholder: "Buscar por nome...",
    type: "text" as const,
  },
  {
    name: "email",
    label: "Email",
    placeholder: "Buscar por email...",
    type: "email" as const,
  },
  {
    name: "lojaId",
    label: "Loja",
    placeholder: "Selecione uma loja...",
    type: "select" as const,
  },
  {
    name: "roleId",
    label: "Cargo",
    placeholder: "Selecione um cargo...",
    type: "select" as const,
  },
  {
    name: "ativo",
    label: "Status",
    placeholder: "Todos",
    type: "select" as const,
    options: [
      { value: "", label: "Todos" },
      { value: "true", label: "Ativo" },
      { value: "false", label: "Inativo" },
    ],
  },
];
